'use client'

// src/tv/live.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LiveTvIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "44",
      height: "44",
      viewBox: "0 0 44 44",
      fill: "none",
      className,
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M36.6667 12.8334H7.33333C6.32081 12.8334 5.5 13.5956 5.5 14.5358V34.9643C5.5 35.9045 6.32081 36.6667 7.33333 36.6667H36.6667C37.6792 36.6667 38.5 35.9045 38.5 34.9643V14.5358C38.5 13.5956 37.6792 12.8334 36.6667 12.8334Z",
            stroke: "currentColor",
            strokeWidth: "3.66667",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.67111 29.2873V20.1666H11.5994V27.6974H15.5096V29.2873H9.67111Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M18.2326 20.1666V29.2873H16.3042V20.1666H18.2326Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20.9846 20.1666L23.189 27.0962H23.2736L25.4825 20.1666H27.6202L24.476 29.2873H21.991L18.8424 20.1666H20.9846Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M28.2356 29.2873V20.1666H34.3813V21.7565H30.1639V23.9298H34.0651V25.5197H30.1639V27.6974H34.3992V29.2873H28.2356Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.8333 12.8333L31.1667 5.5",
            stroke: "currentColor",
            strokeWidth: "3.66667",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20.1667 12.8333L12.8333 5.5",
            stroke: "currentColor",
            strokeWidth: "3.66667",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
};

export {
  LiveTvIcon
};
//# sourceMappingURL=chunk-TPI35Z5K.mjs.map